<template>
    <div class="section-box">
         <div class="act-content">
             <div class="mod-one">
                 <div class="title">主场数据</div>
                 <div class="flex">
                     <el-select v-model="homedata" placeholder="" @change="getPdata" class="ml-20" size="medium">
                         <el-option label="全站" value="-1"></el-option>
                         <el-option label="PC主站" value="1"></el-option>
                         <el-option label="移动站" value="2"></el-option>
                     </el-select>
                     <el-date-picker
                             class="ml-20"
                             size="medium"
                             v-model="dataTime"
                             type="daterange"
                             format="yyyy-MM-dd"
                             value-format="yyyy-MM-dd"
                             range-separator="至"
                             start-placeholder="开始日期"
                             end-placeholder="结束日期"
                             style="width: 20%;"
                             @change="getPdata"
                     ></el-date-picker>
                     <div class="pvnum ml-20">
                         <span>PV：{{pvnum}}</span>
                         <span class="ml-20">UV：{{uvnum}}</span>
                     </div>
                 </div>
             </div>
             <div class="mod-two">
                 <div class="title">直播视频</div>
                 <div class="flex">
                     <div class="ml-20">直播开始时间</div>
                     <el-date-picker
                             class="ml-20"
                             size="medium"
                             v-model="zbstartTime"
                             type="datetime"
                             placeholder="选择日期"
                             format="yyyy-MM-dd HH:mm"
                             value-format="yyyy-MM-dd HH:mm"
                             @change="SetVtime"
                     >
                     </el-date-picker>
                     <div class="ml-20">
                         锦鲤号码：
                         <span style="font-weight: bold" v-if="currentModel.num">{{currentModel.num}}</span>
                         <el-button size="medium" type="primary" v-else @click="opennumPop">输入</el-button>
                     </div>
                 </div>
                 <div class="ml-20">
                     <el-upload class="avatar-uploader el-upload--text mt-20"  action :http-request="Upload"
                                :before-upload="beforeAvatarUpload" :on-preview="handlePreview" :before-remove="beforeRemove"
                                :on-remove="handleRemove" :on-success="handleSuccess" drag :file-list="fileList"
                                accept=".mp4" :show-file-list="false">
                                 <span class="timeDom"
                                       v-if="videoForm.Video != '' && videoFlag == false && stimeSpan != '0'"><img
                                         src="@/assets/video.png" alt="" class="videoIcon2"><b
                                         v-text="resultFormat(stimeSpan)"></b></span>
                         <video v-if="videoForm.Video != '' && videoFlag == false"
                                :src="videoForm.Video" class="avatar" controls="controls">
                             您的浏览器不支持视频播放
                         </video>
                         <i  v-if="videoForm.Video == '' && videoFlag == false" class="el-icon-plus avatar-uploader-icon"></i>
                         <el-progress v-if="videoFlag == true" type="circle" :percentage="progress"
                                      style="margin-top: 10px"></el-progress>
                     </el-upload>
                     <el-button size="small" type="danger" v-if="videoForm.Video"
                                @click="videoForm.Video = '';videoForm.videoUploadId = '';">删除文件重新上传
                     </el-button>
                     <br />
                     <span class="tipsCls">仅限MP4，大小不超过10G</span>
                 </div>
             </div>
             <div class="mod-three mt-20" v-loading="uploadLoading">
                 <div class="title">预热视频</div>
                 <div class="up-button"><span>仅限MP4，大小不超过10G</span>
                     <el-upload
                             action
                             :disabled="uploadLoading"
                             :http-request="Upload2"
                             accept=".mp4"
                             name="video"
                             v-bind:before-upload="beforeAvatarUpload2"
                             v-bind:show-file-list="false"
                     >
                         <el-button size="mini" type="primary">上传预热视频</el-button>
                     </el-upload>
                 </div>
                 <!-- 列表 -->
                 <el-table
                         :stripe="true"
                         :data="tableData"
                         style="width: 100%"
                         border
                         v-loading="listLoading"
                 >
                       <el-table-column label="序号" >
                             <template slot-scope="scope">
                                 <span>{{scope.row.Index || '--'}}</span>
                             </template>
                         </el-table-column>
                         <el-table-column label="视频名称"  show-overflow-tooltip>
                             <template slot-scope="scope">
                                  <span>{{scope.row.VideoName || '--'}}</span>
                             </template>
                         </el-table-column>
                      <el-table-column label="操作" fixed="right" width="300">
                         <template slot-scope="scope">
                             <el-button size="mini" type="danger" @click="deleteVideo(scope.row,1)">删除</el-button>
                             <template v-if="tableData.length > 1">
                                <el-button v-if="scope.row.IsMinSortNo || !scope.row.IsMaxSortNo && !scope.row.IsMinSortNo" size="mini" type="info" plain @click="upDownMove(scope.row.Id, 1,1)">上移</el-button>
                                <el-button v-if="scope.row.IsMaxSortNo || !scope.row.IsMaxSortNo && !scope.row.IsMinSortNo" size="mini" type="info" plain @click="upDownMove(scope.row.Id, -1,1)">下移</el-button>
                             </template>
                         </template>
                     </el-table-column>
                 </el-table>
                 <div style="margin: 10px;overflow: hidden">
                     <div style="float: right;" v-show="tableData">
                         <el-pagination
                                 @size-change="handleSizeChange"
                                 @current-change="handleCurrentChange"
                                 :current-page="form.PageIndex"
                                 :page-sizes="[10, 20, 50, 100, 200]"
                                 :page-size="form.PageSize"
                                 layout="total, sizes, prev, pager, next, jumper"
                                 :total="total">
                         </el-pagination>
                     </div>
                 </div>
             </div>
             <div class="mod-four mt-20">
                 <div class="title">大咖观点</div>
                 <div class="up-button"><span>仅限MP4，大小不超过10G</span><el-button size="mini" type="primary" @click="opendkPop()">上传大咖视频</el-button></div>
                 <!-- 列表 -->
                 <el-table
                         :stripe="true"
                         :data="tableData2"
                         style="width: 100%"
                         border
                         v-loading="listLoading2"
                 >
                     <el-table-column label="序号" >
                         <template slot-scope="scope">
                             <span>{{scope.row.Index || '--'}}</span>
                         </template>
                     </el-table-column>
                     <el-table-column label="视频名称"  show-overflow-tooltip>
                         <template slot-scope="scope">
                             <span>{{scope.row.VideoName || '--'}}</span>
                         </template>
                     </el-table-column>
                     <el-table-column label="操作" fixed="right" width="300">
                         <template slot-scope="scope">
                             <el-button type="primary" size="mini" @click="showdkEdit(scope.row)">编辑</el-button>
                             <!--<el-button size="mini" type="danger" @click="deleteVideo(scope.row,2)">删除</el-button>-->
                             <template v-if="tableData2.length > 1">
                                <el-button v-if="scope.row.IsMinSortNo || !scope.row.IsMaxSortNo && !scope.row.IsMinSortNo" size="mini" type="info" plain @click="upDownMove(scope.row.Id, 1,2)">上移</el-button>
                                <el-button v-if="scope.row.IsMaxSortNo || !scope.row.IsMaxSortNo && !scope.row.IsMinSortNo" size="mini" type="info" plain @click="upDownMove(scope.row.Id, -1,2)">下移</el-button>
                             </template>
                         </template>
                     </el-table-column>
                 </el-table>
                 <div style="margin: 10px;overflow: hidden">
                     <div style="float: right;" v-show="tableData2">
                         <el-pagination
                                 @size-change="handleSizeChange2"
                                 @current-change="handleCurrentChange2"
                                 :current-page="form2.PageIndex"
                                 :page-sizes="[10, 20, 50, 100, 200]"
                                 :page-size="form2.PageSize"
                                 layout="total, sizes, prev, pager, next, jumper"
                                 :total="total2">
                         </el-pagination>
                     </div>
                 </div>
             </div>
             <div class="mod-five mt-20">
                 <div class="title">友情赞助</div>
                 <div class="up-button"><el-button size="mini" type="primary" @click="openSPPop()">添加赞助商</el-button></div>
                 <!-- 列表 -->
                 <el-table
                         :stripe="true"
                         :data="tableData3"
                         style="width: 100%"
                         border
                         v-loading="listLoading3"
                 >
                     <el-table-column label="序号" >
                         <template slot-scope="scope">
                             <span>{{scope.row.Index || '--'}}</span>
                         </template>
                     </el-table-column>
                     <el-table-column label="赞助商名称"  show-overflow-tooltip>
                         <template slot-scope="scope">
                             <span>{{scope.row.SponsorName || '--'}}</span>
                         </template>
                     </el-table-column>
                     <el-table-column label="赞助商LOGO">
                         <template slot-scope="scope">
                             <img class="imgwidth" :src="scope.row.LogoUrl" v-if="scope.row.LogoUrl">
                             <span v-else>暂无LOGO</span>
                         </template>
                     </el-table-column>
                     <el-table-column label="赞助商网址"  show-overflow-tooltip>
                         <template slot-scope="scope">
                             <span>{{scope.row.SponsorSiteUrl || '--'}}</span>
                         </template>
                     </el-table-column>
                     <el-table-column label="赞助商介绍"  show-overflow-tooltip>
                         <template slot-scope="scope">
                             <span>{{scope.row.SponsorIntroduce || '--'}}</span>
                         </template>
                     </el-table-column>
                     <el-table-column label="操作" fixed="right" width="300">
                         <template slot-scope="scope">
                             <el-button type="primary" size="mini" @click="showspEdit(scope.row)">编辑</el-button>
                             <template v-if="tableData3.length > 1">
                                <el-button v-if="scope.row.IsMinSortNo || !scope.row.IsMaxSortNo && !scope.row.IsMinSortNo" size="mini" type="info" plain @click="upDownYQMove(scope.row.Id, 1)">上移</el-button>
                                <el-button v-if="scope.row.IsMaxSortNo || !scope.row.IsMaxSortNo && !scope.row.IsMinSortNo" size="mini" type="info" plain @click="upDownYQMove(scope.row.Id, -1)">下移</el-button>
                             </template>
                         </template>
                     </el-table-column>
                 </el-table>
                 <div style="margin: 10px;overflow: hidden">
                     <div style="float: right;" v-show="tableData3">
                         <el-pagination
                                 @size-change="handleSizeChange3"
                                 @current-change="handleCurrentChange3"
                                 :current-page="form3.PageIndex"
                                 :page-sizes="[10, 20, 50, 100, 200]"
                                 :page-size="form3.PageSize"
                                 layout="total, sizes, prev, pager, next, jumper"
                                 :total="total3">
                         </el-pagination>
                     </div>
                 </div>
             </div>
         </div>
        <el-dialog
                title="锦鲤号码"
                :visible="showNumModel"
                :close-on-click-modal="!showNumModel"
                :before-close="close"
                width="600px"
        >
            <div class="Koicontent">
                <h2>锦鲤号码</h2>
                <el-form ref="form" :model="currentModel" label-width="80px" :rules="rules">
                    <el-form-item label="" prop="num">
                        <el-input v-model.trim="currentModel.num"  oninput ="value=value.replace(/[^0-9.]/g,'')" placeholder="请输入八位锦鲤号码" class="edit_input" style="width: 410px"></el-input>
                    </el-form-item>
                    <h3 class="red">请谨慎输入，一旦确认则无法变更！</h3>
                </el-form>
                <div class="dialog-footer" style="text-align: center;margin-top: 50px;" slot="footer">
                    <el-button type="primary" @click="confirmNum">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <dk-popup
                ref="editComWare"
                v-if="showEditdk"
                :current-param="currentdkParam"
                @close="closeEdit"
                @refreshList="successToEdit">
        </dk-popup>
        <spon-popup
                ref="editComWare"
                v-if="showEditsp"
                :current-param="currentspParam"
                @close="closespEdit"
                @refreshList="successToEditsp">
        </spon-popup>
    </div>
</template>
<script>
    import {
        client,
        getFileNameUUID
    } from "@/utils/ali-oss"; //前面的ali-js文件内的两个封装函数
    import {
        SetVideo,SetVideoTime,getPUVdata,getVideoInfo,setPrizeNo,getListData,getListSponsor,setuploadVideo,deleteListVideo,moveListVideo,moveListYQ
    } from "@/service/run";
    import dkPopup from './actPopup/dkPopup';
    import sponPopup from './actPopup/sponPopup';
    export default {
        name:'serviceBBS',
        components:{ dkPopup,sponPopup},
        data() {
            return {
                homedata:'-1',
                dataTime:'',
                zbstartTime:'',
                fileList: [], //文件列
                //   showProgress: false,//进度条的显示
                progress: 0, //进度条数据
                videoFlag: false,
                videoForm: {
                    Video: "",
                    videoUploadId: "",
                },
                stimeSpan:0,
                pvnum:0,
                uvnum:0,
                showNumModel:false,
                currentModel:{
                    num:''
                },
                rules:{
                    num: [
                        { required: true,
                            message: "锦鲤号码不能为空",
                            trigger: "blur"
                        },
                        { min: 8, max: 8, message: '锦鲤号码为8位数字！', trigger: 'blur' }
                    ],
                },
                // 预热视频
                tableData:[],
                listLoading:false,
                form: {
                    PageIndex: 1,
                    PageSize: 10
                },
                total: 0,
                //大咖观点
                tableData2:[],
                listLoading2:false,
                form2: {
                    PageIndex: 1,
                    PageSize: 10
                },
                total2: 0,
                //友情赞助
                tableData3:[],
                listLoading3:false,
                form3: {
                    PageIndex: 1,
                    PageSize: 10
                },
                total3: 0,
                //预热视频上传
                uploadLoading:false,
                videoForm2: {
                    Video: "",
                    videoUploadId: "",
                    videoname:"",
                    stimeSpan2:0
                },
                showEditdk:false,
                currentdkParam:{},
                //友情赞助
                showEditsp:false,
                currentspParam:{}
            }
        },
        methods:{
            //友情赞助
            async getSponsorList(){
                this.listLoading3 = true;
                let params = {
                    PageIndex:this.form3.PageIndex,
                    PageSize:this.form3.PageSize,
                }
                let res = await getListSponsor(params)
                this.listLoading3 = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.tableData3 = res.Data.List || [];
                this.total3 = res.Data.TotalRows
            },
            //视频列表
            async getVideoList(index){
                if(index==1){
                    this.listLoading = true;
                    let params = {
                        PageIndex:this.form.PageIndex,
                        PageSize:this.form.PageSize,
                        VideoType:index
                    }
                    let res = await getListData(params)
                    this.listLoading = false
                    if(res.Result != 1) {
                        return this.$message.error('获取失败请联系开发人员')
                    }
                    this.tableData = res.Data.List || [];
                    this.total = res.Data.TotalRows
                }
                if(index==2){
                    this.listLoading2 = true;
                    let params = {
                        PageIndex:this.form2.PageIndex,
                        PageSize:this.form2.PageSize,
                        VideoType:index
                    }
                    let res = await getListData(params)
                    this.listLoading2 = false
                    if(res.Result != 1) {
                        return this.$message.error('获取失败请联系开发人员')
                    }
                    this.tableData2 = res.Data.List || [];
                    this.total2 = res.Data.TotalRows
                }
            },
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.PageIndex = 1
                this.form.PageSize = val;
                this.getVideoList(1);
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.PageIndex = val;
                this.getVideoList(1);
            },
            handleSizeChange2(val) {
                if (this.listLoading2) return
                this.form2.PageIndex = 1
                this.form2.PageSize = val;
                this.getVideoList(2);
            },
            handleCurrentChange2(val) {
                if (this.listLoading2) return
                this.form2.PageIndex = val;
                this.getVideoList(2);
            },
            handleSizeChange3(val) {
                if (this.listLoading3) return
                this.form3.PageIndex = 1
                this.form3.PageSize = val;
                this.getSponsorList();
            },
            handleCurrentChange3(val) {
                if (this.listLoading3) return
                this.form3.PageIndex = val;
                this.getSponsorList();
            },
            //日期时间处理
            convert(val) {
                return val < 10 ? '0' + val : val
            },
            // 获取当前时间
            getDate() {
                const myDate = new Date()
                //获取当前年
                const year = myDate.getFullYear()
                //获取当前月
                const month = myDate.getMonth() + 1
                //获取当前日
                const date = myDate.getDate()
                //获取当前小时数(0-23)
                const h = myDate.getHours()
                //获取当前分钟数(0-59)
                const m = myDate.getMinutes()

                //获取当前时间
                const time =
                    year +
                    '-' +
                    this.convert(month) +
                    '-' +
                    this.convert(date) +
                    ' ' +
                    this.convert(h) +
                    ':' +
                    this.convert(m)
                return time
            },
            opennumPop(){
                let nodate =this.getDate();
                console.log(nodate>this.zbstartTime)
                if(nodate>this.zbstartTime){
                    this.currentModel={
                        num:''
                    };
                    this.showNumModel=true;
                }else{
                    this.$message.warning("直播开始时间之后才可以输入锦鲤号码")
                }

            },
            confirmNum(){
                this.$refs['form'].validate((valid) => {
                        if(valid){
                            let param={
                                WinPrizeNo:this.currentModel.num
                            }
                            setPrizeNo(param).then(res=>{
                                if(res.Result != 1) {
                                    return this.$message.error(res.Message)
                                }
                                this.showNumModel=false;
                                this.$message.success("设置成功")
                            })
                        }
                })
            },
            close(){
                this.showNumModel=false
            },
            //获取直播信息
            getVInfo(){
                getVideoInfo().then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    const datas = res.Data;
                    this.zbstartTime=datas.LiveStreamingStartTime;
                    this.videoForm.Video=datas.LiveStreamingVideoUrl;
                    if(datas.WinPrizeNo){
                        this.currentModel.num=datas.WinPrizeNo;
                    }
                })
            },
            //主场数据
            getPdata(){
                console.log("dataTime",this.dataTime)
                var params = {
                    PlatformType:parseInt(this.homedata),
                };
                if(this.dataTime){
                    params.StartTime=this.dataTime[0];
                    params.EndTime=this.dataTime[1]
                }
                getPUVdata(params).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.pvnum=res.Data.PVCount;
                    this.uvnum=res.Data.UVCount;
                })
            },
            //设置直播时间
            SetVtime(){
                var params = {
                    StartTime:this.zbstartTime
                };
                SetVideoTime(params).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success("设置成功")
                })
            },
            //文件上传前的校验
            beforeAvatarUpload(file) {
                const _this = this
                //file.size返回b单位
                const isLt10M = file.size/1024/1024/1024<10;
                if (
                    [
                        "video/mp4",
                        "video/ogg",
                        "video/flv",
                        "video/avi",
                        "video/wmv",
                        "video/rmvb",
                    ].indexOf(file.type) == -1
                ) {
                    this.$message.error("请上传正确的视频格式");
                    return false;
                }
                if (!isLt10M) {
                    this.$message.error("上传视频大小不能超过10G哦!");
                    return false;
                }
                // 获取视频时长
                var url = URL.createObjectURL(file);
                var audioElement = new Audio(url);
                var duration;
                audioElement.addEventListener("loadedmetadata", function (_event) {
                    duration = audioElement.duration; //时长为秒，小数，182.36
                    _this.stimeSpan = parseInt(duration);
                });
                _this.loading = true;
            },
            Upload(file) {
                const config = {
                    region: "oss-cn-zhangjiakou",
                    accessKeyId: "LTAIm1hXML86TVS4",
                    accessKeySecret: "TsgBJS0oD3V0YBkYs6P8XnFVo0GH1O",
                    bucket: "gk-manager",
                };
                const that = this;
                async function multipartUpload() {
                    let temporary = file.file.name.lastIndexOf(".");
                    let fileNameLength = file.file.name.length;
                    let fileFormat = file.file.name.substring(
                        temporary + 1,
                        fileNameLength
                    );
                    let fileName = getFileNameUUID() + "." + fileFormat;
                    client(config)
                        .multipartUpload(`video/${fileName}`, file.file, {
                            progress: function (p) {
                                //p进度条的值
                                // console.log(p);
                                that.videoFlag = true;
                                // that.showProgress = true;
                                that.progress = Math.floor(p * 100);
                            }
                        })
                        .then(result => {
                            //上传成功返回值，可针对项目需求写其他逻辑
                            // console.log(result);
                            // console.log(result.res.requestUrls[0]);
                            that.videoFlag = false;
                            var totalUrl = result.res.requestUrls[0];
                            that.videoForm.videoUploadId = that.getQueryVariable(totalUrl,
                                'uploadId'); //oss没有返回id
                            that.videoForm.Video = totalUrl.split("?")[0];
                            that.SetVideoUrl();
                        }).catch(err => {
                            that.$message.error(err)
                        });
                }
                multipartUpload();
            },
            handlePreview(file) {
            },
            // 删除文件之前的钩子
            beforeRemove(file, fileList) {
                // return this.$confirm(`确定移除 ${file.name}？`);
            },
            // 文件列表移除文件时的钩子
            handleRemove(file, fileList) {
            },
            // 文件上传成功时的钩子
            handleSuccess(response, file, fileList) {
                this.fileList = fileList;
            },
            resultFormat(values) {
                var value = parseInt(values)
                var h = Math.floor(value / 3600);
                var m = Math.floor((value / 60 % 60));
                var s = Math.floor((value % 60));
                if (h < 1) {
                    h = '00'
                }
                if (m < 9) {
                    m = '0' + m
                }
                if (s < 10) {
                    s = '0' + s
                }
                return h + ':' + m + ':' + s
            },
            getQueryVariable(url, paraName) {
                var arrObj = url.split("?");
                if (arrObj.length > 1) {
                    var arrPara = arrObj[1].split("&");
                    var arr;
                    for (var i = 0; i < arrPara.length; i++) {
                        arr = arrPara[i].split("=");
                        if (arr != null && arr[0] == paraName) {
                            return arr[1];
                        }
                    }
                    return "";
                } else {
                    return "";
                }
            },
            SetVideoUrl(){
                var params = {
                    LiveStreamingVideoUrl:this.videoForm.Video,
                    VideoSecond:this.stimeSpan
                };
                SetVideo(params).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success(res.Message)
                })
            },
            Upload2(file) {
                const config = {
                    region: "oss-cn-zhangjiakou",
                    accessKeyId: "LTAIm1hXML86TVS4",
                    accessKeySecret: "TsgBJS0oD3V0YBkYs6P8XnFVo0GH1O",
                    bucket: "gk-manager",
                };
                const that = this;
                async function multipartUpload() {
                    let temporary = file.file.name.lastIndexOf(".");
                    let fileNameLength = file.file.name.length;
                    let fileFormat = file.file.name.substring(
                        temporary + 1,
                        fileNameLength
                    );
                    let fileName = file.file.name + "." + fileFormat;
                    that.videoForm2.videoname = file.file.name.substring(0,temporary);
                    client(config)
                        .multipartUpload(`video/${fileName}`, file.file, {
                            progress: function (p) {
                                //p进度条的值
                                // console.log(p);
                            }
                        })
                        .then(result => {
                            //上传成功返回值，可针对项目需求写其他逻辑
                            // console.log(result);
                            // console.log(result.res.requestUrls[0]);
                            that.uploadLoading = false;
                            var totalUrl = result.res.requestUrls[0];
                            // that.videoForm2.videoname= that.subName(totalUrl)
                            that.videoForm2.videoUploadId = that.getQueryVariable(totalUrl,
                                'uploadId'); //oss没有返回id
                            that.videoForm2.Video = totalUrl.split("?")[0];
                            that.setYrVideo();
                        }).catch(err => {
                        that.uploadLoading = false;
                        that.$message.error(err)
                    });
                }
                multipartUpload();
            },
            //文件上传前的校验
            beforeAvatarUpload2(file) {
                const _this = this
                //file.size返回b单位
                const isLt10M = file.size/1024/1024/1024<10;
                if (
                    [
                        "video/mp4",
                        "video/ogg",
                        "video/flv",
                        "video/avi",
                        "video/wmv",
                        "video/rmvb",
                    ].indexOf(file.type) == -1
                ) {
                    this.$message.error("请上传正确的视频格式");
                    return false;
                }
                if (!isLt10M) {
                    this.$message.error("上传视频大小不能超过10G哦!");
                    return false;
                }
                // 获取视频时长
                var url = URL.createObjectURL(file);
                var audioElement = new Audio(url);
                var duration;
                audioElement.addEventListener("loadedmetadata", function (_event) {
                    duration = audioElement.duration; //时长为秒，小数，182.36
                    _this.videoForm2.stimeSpan2 = parseInt(duration);
                });
                _this.uploadLoading = true;
            },
            subName(data){
                if(data){
                    let urlArr = data.split('?');
                    let k =urlArr[0], appU = k.split('/');
                    let index=appU[4].lastIndexOf(".");
                    let name=appU[4].substring(0,index);
                    return name
                }else{
                    return null
                }

            },
            setYrVideo(){
                var params = {
                    VideoUrl:this.videoForm2.Video,
                    VideoSecond:this.videoForm2.stimeSpan2,
                    VideoName:this.videoForm2.videoname,
                    VideoType:1
                };
                setuploadVideo(params).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.getVideoList(1);
                    this.$message.success(res.Message)
                })
            },
            deleteVideo(rows,index){
                let data = {
                    Id: rows.Id
                }
                deleteListVideo(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error('删除失败，请重新确认删除');
                    }
                    this.$message.success('删除成功！');
                    this.form.PageIndex = 1
                    this.getVideoList(index);
                })
            },
            //上移下移
            upDownMove(id, move,type) {
                var data = {
                    Id: id,
                    VideoType:type,
                    Difference: move,
                }
                moveListVideo(data).then(res => {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success('操作成功！')
                    this.getVideoList(type);
                })
            },
            // 大咖
            closeEdit(){
                this.showEditdk = false
            },
            successToEdit(){
                this.showEditdk = false;
                this.form2.PageIndex=1;
                this.getVideoList(2);
            },
            opendkPop(){
                this.currentdkParam={Id:-1}
                this.showEditdk=true
            },
            showdkEdit(param){
                this.currentdkParam = param
                this.showEditdk = true
            },
            upDownYQMove(id, move) {
                var data = {
                    Id: id,
                    Difference: move,
                }
                moveListYQ(data).then(res => {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success('操作成功！')
                    this.getSponsorList();
                })
            },
            // 友情
            // 大咖
            closespEdit(){
                this.showEditsp = false
            },
            successToEditsp(){
                this.showEditsp = false
                this.form3.PageIndex = 1
                this.getSponsorList();
            },
            openSPPop(){
                this.currentspParam={Id:-1}
                this.showEditsp=true
            },
            showspEdit(param){
                this.currentspParam = param
                this.showEditsp = true
            },
        },
        mounted() {
            this.getPdata();
            this.getVInfo();
            this.getVideoList(1);
            this.getVideoList(2);
            this.getSponsorList();
        }

    }
</script>
<style lang="scss">
    .act-content{
        .mt-20{
            margin-top: 20px;
        }
        .ml-20{
            margin-left: 20px;
        }
        .title{
            font-size: 20px;
            font-weight: bold;
            margin: 20px 0px;
        }
        .flex{
            display: flex;
            height: 40px;
            align-items: center;
        }
        .pvnum{
            font-size: 18px;
            font-weight: bold;
            line-height: 40px;
        }
        .avatar-uploader-icon {
            margin-top: 67px;
        }
        .timeDom {
            display: block;
            position: absolute;
            padding: 2px;
            color: #fff;
            top: 0;
            right: 0;
            z-index: 999;
            background: #000;

            .videoIcon2 {
                height: 18px;
                width: auto;
                vertical-align: text-bottom;
                margin-left: 5px;
            }
        }
        .avatar,
        .el-upload-dragger {
            // width: 148px;
            // height: 148px;
            width: 336px;
            height: 210px;
        }
        .tipsCls {
            font-size: 14px;
            color: #999;
            line-height: 42px;
        }
        .videoIcon .el-form-item__label::before {
            content: "* ";
            color: red;
        }
        .avatar-uploader-icon {
            margin-top: 67px;
        }
        .el-upload-list--text{
            display: none;
        }
        .up-button{
            display: flex;
            justify-content: flex-end;
            margin-bottom: 10px;
            align-items: center;
            > span {
                font-size: 14px;
                color: #999;
            }
            .el-button{
                margin-left: 20px;
            }
        }
        .imgwidth{
            width: 50px;
            height: 50px;
        }
    }
    .Koicontent{
        h2{
            text-align: center;
            margin-bottom: 20px;
        }
        .red{
            color: red;
            text-align: center;
            margin-top: 20px;
        }
    }
</style>
